import StoreBadges from './StoreBadges';

interface Shot {
  src: string;
  alt: string;
  caption: string;
}

// Image names match the output of scripts/frame_screenshots.py for the
// English locale's landing-size variants (no bezel, cover-fit). Run
// scripts/screenshots.{sh,bat} to regenerate these from the live app.
const SHOTS: Shot[] = [
  {
    src: '/screenshots/home.png',
    alt: 'Dashboard with USD and EUR cards',
    caption: 'Dashboard',
  },
  {
    src: '/screenshots/detail.png',
    alt: 'Currency history chart with OHLC tooltip',
    caption: 'Charts',
  },
  {
    src: '/screenshots/converter.png',
    alt: 'Currency converter showing 100 USD to LYD',
    caption: 'Converter',
  },
];

/**
 * 3-up phone mockup row showcasing the app's main screens. Each phone is a
 * pure CSS device frame so the page never depends on a downloaded mockup
 * template. Replace the PNGs in `/public/screenshots/` with real captures
 * before launch.
 */
export default function Screenshots() {
  return (
    <section
      id="screenshots"
      className="relative scroll-mt-24 border-t border-white/5 bg-brand-panel/40 py-24 sm:py-32"
    >
      <div className="container-page">
        <div className="mx-auto max-w-2xl text-center">
          <p className="text-sm font-semibold uppercase tracking-[0.18em] text-brand-cyan">
            See it in action
          </p>
          <h2 className="mt-3 font-display text-3xl font-bold tracking-tight text-white sm:text-4xl">
            A focused, beautiful experience.
          </h2>
          <p className="mt-4 text-base text-slate-400 sm:text-lg">
            Dark Material 3 design, smooth charts, and instant tap-to-convert
            wherever you need a quick LYD number.
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 items-end gap-10 sm:grid-cols-3">
          {SHOTS.map((shot, i) => (
            <figure
              key={shot.caption}
              className="flex flex-col items-center"
              style={{ animationDelay: `${i * 120}ms` }}
            >
              <div className="relative rounded-[2.2rem] border border-white/10 bg-gradient-to-b from-white/10 to-white/[0.02] p-1.5 shadow-glow">
                <div className="absolute left-1/2 top-1.5 z-20 h-4 w-20 -translate-x-1/2 rounded-b-2xl bg-black/70" />
                <img
                  src={shot.src}
                  alt={shot.alt}
                  loading="lazy"
                  className="h-[460px] w-[230px] rounded-[1.8rem] object-cover sm:h-[520px] sm:w-[260px]"
                />
              </div>
              <figcaption className="mt-4 text-xs font-semibold uppercase tracking-[0.18em] text-slate-400">
                {shot.caption}
              </figcaption>
            </figure>
          ))}
        </div>

        <div className="mt-20 flex justify-center">
          <StoreBadges align="center" />
        </div>
      </div>
    </section>
  );
}
